import React from 'react';

/**
 * Appkit 4 "open-in-new-outline" icon, inlined as a React component so it can
 * be recolored via `currentColor` and styled with CSS.
 *
 * Source: Appkit4 icon set (Icon/Outline/open-in-new-outline). The original
 * `fill="#474747"` has been replaced with `currentColor`.
 *
 * @param {React.SVGProps<SVGSVGElement>} props
 */
export default function OpenInNewOutlineIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      role="img"
      focusable="false"
      aria-hidden="true"
      {...props}
    >
      <g fill="currentColor" fillRule="nonzero">
        <path d="M22.5,12 L24,12 L24,22 C24,23.1045696 23.1045696,24 22,24 L2,24 C0.895430501,24 0,23.1045696 0,22 L0,2 C0,0.895430501 0.895430501,0 2,0 L12,0 L12,1.5 L2,1.5 C1.72385763,1.5 1.5,1.72385763 1.5,2 L1.5,22 C1.5,22.2761425 1.72385763,22.5 2,22.5 L22,22.5 C22.2761425,22.5 22.5,22.2761425 22.5,22 L22.5,12 Z M10.0487672,14.9589042 L9.00000004,13.9232878 L21.4471234,1.47945206 L15.9764384,1.47945206 C15.567899,1.47945206 15.2367124,1.14826544 15.2367124,0.739726031 C15.2367124,0.331186625 15.567899,0 15.9764384,0 L23.9720549,0 L23.9720549,7.99561646 C23.9720549,8.40415586 23.6408683,8.73534251 23.2323289,8.73534251 C22.8237895,8.73534251 22.4926028,8.40415586 22.4926028,7.99561646 L22.4926028,2.52493152 L10.0487672,14.9589042 Z" />
      </g>
    </svg>
  );
}
